import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import EventServices from "../services/EventServices";
import useAsync from "../hooks/useAsync";
import Modal from "react-modal";
import DeleteButton from "./Button/DeleteButton";
import EventUpdate from "./Update Model/UpdateEvent";
import ViewBookingEvent from "./View Model/ViewBookingEvent";
import Pagination from "./Common/Pagination";
Modal.setAppElement("#root");
function EventBookingList() {
    const [currentPage, setCurrentPage] = useState(1);
    console.log("currentpage",currentPage)
    const [event, setEvent] = useState([]);
    const [eventId, setEventId] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [isDownloading, setIsDownloading] = useState(false);
    const [paymentStatus, setPaymentStatus] = useState("");
    const [bookingStatus, setBookingStatus] = useState("");
    const [checkInStatus, setCheckInStatus] = useState("");
    const [limit] = useState(10);
    const fetchEvents = useCallback(() => {
        return EventServices.getEventBooking(
            currentPage,
            limit,
            eventId,
            paymentStatus,
            bookingStatus,
            checkInStatus
        );
    }, [
        currentPage,
        limit,
        eventId,
        paymentStatus,
        bookingStatus,
        checkInStatus,
    ]);

    const { data, error, loading: isLoading, run, } = useAsync(fetchEvents);
    console.log("FULL DATA FROM useAsync:", data);  // 👈 Ye add karo
console.log("PAGINATION:", data?.pagination); 
    const events = data?.data || [];
    const pagination = data?.pagination || {};

    const totalPages = pagination?.totalPages || 0;
    const totalItems = pagination?.total || 0;

    const count = totalItems;
    const [activeIndex, setActiveIndex] =
        useState(null);
    const [isEditModalOpen, setIsEditModalOpen] =
        useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] =
        useState(false);

    const [isModalOpen, setIsModalOpen] =
        useState(false);

    const [selectedEdit, setSelectedEdit] = useState(null);

    const [selectedEvent, setSelectedEvent] = useState(null);
    const toggleActionMenu = (index) => {

        setActiveIndex(
            index === activeIndex
                ? null
                : index
        );
    };
    function formatDateTime(dateValue) {
        if (!dateValue) return "N/A";
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) return "N/A";
        return date.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    }
    const handleDownloadCSV = async () => {
        try {
            setIsDownloading(true);

            const response = await EventServices.getEventBookingCSV(
                currentPage,
                limit,
                eventId,
                searchQuery,
                paymentStatus,
                bookingStatus,
                checkInStatus
            );

            // response is already a Blob
            const url = window.URL.createObjectURL(response);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "event-bookings.csv");

            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);
            setEventId("");
            setSearchQuery("");
            setPaymentStatus("");
            setBookingStatus("");
            setCheckInStatus("");
            setCurrentPage(1);
        } catch (error) {
            console.error("CSV Download Error:", error);
        } finally {
            setIsDownloading(false);
        }
    };
    useEffect(() => {
        const fetchActiveEvents = async () => {
            try {
                const res = await EventServices.getActiveEvents();

                console.log("Active Events:", res);

                if (res?.status) {
                    setEvent(res?.data || []);
                }
            } catch (error) {
                console.error("Get Active Events Error:", error);
            }
        };

        fetchActiveEvents();
    }, []);
    function formatTime(timeStr) {
        if (!timeStr) return "";
        const [h, m] = timeStr.split(":");
        const hour = Number(h);
        const ampm = hour >= 12 ? "PM" : "AM";
        const h12 = hour % 12 || 12;
        return `${h12}:${m} ${ampm}`;
    }

    const handleEditDetails = (event) => {

        setSelectedEdit(event);

        setIsEditModalOpen(true);

        toggleActionMenu(null);
    };

    // ==========================================
    // DELETE
    // ==========================================
    const handleDelete = (event) => {

        setSelectedEdit(event);

        setIsDeleteModalOpen(true);

        toggleActionMenu(null);
    };

    const handleViewDetails = (event) => {

        setSelectedEvent(event);

        setIsModalOpen(true);

        toggleActionMenu(null);
    };

    // ==========================================
    // CLOSE EDIT
    // ==========================================
    const closeEditModal = () => {

        setIsEditModalOpen(false);

        setSelectedEdit(null);
    };

    const closeDeleteModal = () => {

        setIsDeleteModalOpen(false);

        setSelectedEdit(null);
    };
    const closeModal = () => {

        setIsModalOpen(false);

        setSelectedEvent(null);
    };
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };
    function formatDateTime(dateValue) {

        if (!dateValue) {
            return "N/A";
        }

        const date = new Date(dateValue);

        if (isNaN(date.getTime())) {
            return "N/A";
        }

        return date.toLocaleDateString("en-IN");
    }

    // ==========================================
    // LOADING
    // ==========================================
    // if (isLoading) {
    //     return (
    //         <div className="right_col" role="main">
    //             <div className="container-box">
    //                 <div className="container-box-inner">
    //                     <p>Loading events...</p>
    //                 </div>
    //             </div>
    //         </div>
    //     );
    // }
    return (
        <>
            <div
                className="right_col"
                role="main"
            >
                <div className="title-box">

                    <h2>
                        Events Booking List{" "}

                        <span className="badge bg-orange">
                            {count}
                        </span>
                    </h2>

                    {/* <div className="container-box-top-header-right">
                        <Link
                            className="round-add-btn"
                            to="/create-event-booking"
                        >
                            <img
                                src="img/plus.svg"
                                alt=""
                            />
                        </Link>
                    </div> */}
                </div>
                <div className="container-box px-0 pt-2">
                    <div className="Tablesearch_design">
                        <div className='row'>
                            {/* <div className='col-sm-6 col-md-6'>
                                <div className='d-flex align-items-center justify-content-between gap-2'>
                                    <div className=' w-100'>
                                        <input
                                            type="search"
                                            name="search"
                                            placeholder="Search by Name, Mobile and Email id"
                                            value={searchQuery}
                                            onChange={handleSearchChange}
                                            className='form-control'
                                        />
                                    </div>
                                    <div>
                                        <button className="search-btn">Search</button>
                                    </div>
                                </div>
                            </div> */}
                            {/* <div className="col-sm-3 col-6">

              <div className="input-field">
                <select className="form-select selectcustum" value={userTypeFilter} onChange={handleUserTypeChange}>
                  <option value="">Seller Type</option>
                  <option value="Android">Android</option>
                  <option value="iOS">iOS</option>
                </select>
              </div></div> */}


                            <div className="row g-2 align-items-end">


                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                                    <div className="input-field">
                                        <select
                                            className="form-select selectcustum"
                                            value={eventId}
                                            onChange={(e) => {
                                                setEventId(e.target.value);
                                                setCurrentPage(1);
                                            }}
                                        >
                                            <option value="">Select Event</option>

                                            {event.map((eventItem) => (
                                                <option
                                                    key={eventItem?._id}
                                                    value={eventItem?._id}
                                                >
                                                    {eventItem?.eventName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>


                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                                    <div className="input-field">
                                        <select
                                            className="form-select selectcustum"
                                            value={paymentStatus}
                                            onChange={(e) => {
                                                setPaymentStatus(e.target.value);
                                                setCurrentPage(1);
                                            }}
                                        >
                                            <option value="">Payment Status</option>
                                            <option value="Success">Success</option>
                                            <option value="Pending">Pending</option>
                                            <option value="Failed">Failed</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="col-xl-2 col-lg-2 col-md-6 col-sm-6">
                                    <div className="input-field">
                                        <select
                                            className="form-select selectcustum"
                                            value={bookingStatus}
                                            onChange={(e) => {
                                                setBookingStatus(e.target.value);
                                                setCurrentPage(1);
                                            }}
                                        >
                                            <option value="">Booking Status</option>
                                            <option value="Confirmed">Confirmed</option>
                                            <option value="Pending">Pending</option>
                                            <option value="Cancelled">Cancelled</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-2 col-md-6 col-sm-6">
                                    <div className="input-field">
                                        <select
                                            className="form-select selectcustum"
                                            value={checkInStatus}
                                            onChange={(e) => {
                                                setCheckInStatus(e.target.value);
                                                setCurrentPage(1);
                                            }}
                                        >
                                            <option value="">Check-In Status</option>
                                            <option value="Pending">Pending</option>
                                            <option value="Checked-In">Checked-In</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="col-xl-2 col-lg-2 col-md-6 col-sm-6">
                                    <button
                                        type="button"
                                        className="btn btn-primary w-100"
                                        onClick={handleDownloadCSV}
                                        disabled={isDownloading}
                                    >
                                        {isDownloading ? "Exporting..." : "Export CSV"}
                                    </button>
                                </div>

                            </div>


                        </div>



                    </div>
                    <div className="container-box-inner table-reponsive-tabe">

                        <table
                            id="example"
                            className="table table-striped"
                            style={{
                                width: "100%"
                            }}
                        >

                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Booking ID</th>
                                    <th>Event</th>
                                    <th>Image</th>
                                    <th>Date</th>
                                    <th>User</th>
                                    <th>Ticket</th>
                                    <th>Amount</th>
                                    <th>Payment</th>
                                    <th>Booking</th>
                                    <th>Check-In</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan="12" className="text-center">
                                            Loading bookings...
                                        </td>
                                    </tr>
                                ) :
                                    events.length > 0 ? (
                                        events.map((event, i) => (
                                            <tr
                                                key={event?._id || i}
                                            >
                                                <td>
                                                    {(Number(currentPage) - 1) * Number(limit) + i + 1}
                                                </td>

                                                <td>
                                                    {event?.bookingId || "N/A"}
                                                </td>

                                                <td>
                                                    {event?.eventId?.eventName || "N/A"}
                                                </td>

                                                <td>
                                                    <div className="product-img">
                                                        {event?.eventId?.eventBanner ? (
                                                            <img
                                                                src={
                                                                    process.env.REACT_APP_URL +
                                                                    event.eventId.eventBanner
                                                                }
                                                                alt={event?.eventId?.eventName || "Event"}
                                                                style={{
                                                                    height: "70px",
                                                                    width: "70px",
                                                                    objectFit: "contain",
                                                                }}
                                                            />
                                                        ) : (
                                                            <span>N/A</span>
                                                        )}
                                                    </div>
                                                </td>
                                                <td>
                                                    {formatDateTime(event?.eventId?.eventDate)}
                                                </td>
                                                <td>
                                                    {event?.userId?.firstName || ""}
                                                    {" "}
                                                    {event?.userId?.lastName || ""}
                                                    {event?.userId?.mobileNo && (
                                                        <div
                                                            style={{
                                                                fontSize: "12px",
                                                                color: "#666",
                                                            }}
                                                        >
                                                            {event.userId.mobileNo}
                                                        </div>
                                                    )}
                                                </td>
                                                <td>
                                                    {event?.ticketName || "N/A"}
                                                    <div
                                                        style={{
                                                            fontSize: "12px",
                                                            color: "#666",
                                                        }}
                                                    >
                                                        Qty: {event?.quantity || 0}
                                                    </div>
                                                </td>
                                                <td>
                                                    ₹{event?.totalAmount || 0}
                                                </td>
                                                <td>
                                                    <span
                                                        className={
                                                            event?.paymentStatus === "Success"
                                                                ? "badge bg-success"
                                                                : "badge bg-warning text-dark"
                                                        }
                                                    >
                                                        {event?.paymentStatus || "N/A"}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span
                                                        className={
                                                            event?.bookingStatus === "Confirmed"
                                                                ? "badge bg-success"
                                                                : "badge bg-secondary"
                                                        }
                                                    >
                                                        {event?.bookingStatus || "N/A"}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span
                                                        className={
                                                            event?.checkInStatus === "Checked-In"
                                                                ? "badge bg-success"
                                                                : "badge bg-secondary"
                                                        }
                                                    >
                                                        {event?.checkInStatus || "N/A"}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="action_toggle_outer">
                                                        <button
                                                            className="action_toggle"
                                                            onClick={() =>
                                                                toggleActionMenu(i)
                                                            }
                                                        >
                                                            <i className="fa fa-ellipsis-v" />
                                                        </button>

                                                        {activeIndex === i && (
                                                            <div className="action_toggle_content product-edit show d-block">
                                                                <ul className="list-unstyled">

                                                                    <li>
                                                                        <button
                                                                            className="close_toggle"
                                                                            onClick={() =>
                                                                                toggleActionMenu(null)
                                                                            }
                                                                        >
                                                                            <i className="fa fa-close" />
                                                                        </button>
                                                                    </li>

                                                                    <li>
                                                                        <button
                                                                            className="approve"
                                                                            style={{
                                                                                backgroundColor: "#263238",
                                                                            }}
                                                                            onClick={() =>
                                                                                handleViewDetails(event)
                                                                            }
                                                                        >
                                                                            View
                                                                        </button>
                                                                    </li>

                                                                    {/* <li>
                                                                    <button
                                                                        className="edit"
                                                                        onClick={() =>
                                                                            handleEditDetails(event)
                                                                        }
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </li>

                                                                <li>
                                                                    <button
                                                                        className="reject"
                                                                        onClick={() =>
                                                                            handleDelete(event)
                                                                        }
                                                                    >
                                                                        Delete
                                                                    </button>
                                                                </li> */}

                                                                </ul>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="12" className="text-center">
                                                No bookings found
                                            </td>
                                        </tr>
                                    )}
                            </tbody>

                        </table>

                    </div>

                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={setCurrentPage}
                />
                </div>
      
                <Modal
                    isOpen={isEditModalOpen}
                    onRequestClose={closeEditModal}
                    contentLabel="Event Edit"
                    className="modal-content"
                    overlayClassName="modal-overlay"
                >

                    <EventUpdate
                        user={selectedEdit}
                        closeModal={closeEditModal}
                        onSuccess={run}
                    />

                </Modal>
                <Modal
                    isOpen={isModalOpen}
                    onRequestClose={closeModal}
                    contentLabel="View Event"
                    className="modal-content"
                    overlayClassName="modal-overlay"
                >

                    <ViewBookingEvent
                        user={selectedEvent}
                        closeModal={closeModal}
                    />

                </Modal>
                <Modal
                    isOpen={isDeleteModalOpen}
                    onRequestClose={closeDeleteModal}
                    contentLabel="Delete Confirmation"
                    className="modal-content"
                    overlayClassName="modal-overlay"
                >

                    <DeleteButton
                        data={selectedEdit}
                        page="delete-event"
                        closeModal={closeDeleteModal}
                        onSuccess={run}
                    />

                </Modal>

            </div>
        </>
    );
}

export default EventBookingList;